/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { gte } from '@ember/object/computed';
import { format } from 'd3-format';

import DS from 'ember-data';
import actionInfo from 'cio/utils/action-info';
import { Measure, SPAM_WARN_LEVEL } from 'cio/utils/metrics/common';

import { ActionType } from 'cio/models/action';
import { Metric } from 'cio/utils/metrics/models/metric';

interface CioMetricSummaryArgs {
  actionId: number;
  actionType: string;
  conversion: boolean;
  link?: boolean;
  metric: DS.PromiseObject<Metric>;
  routeName: string;
  isLoading?: boolean;
  showDeletedItemsMetricsNotice?: boolean;
  title?: string;
  visibleMetrics?: Measure[];
  useMessageLimits?: boolean;
}

export default class CioMetricSummary extends Component<CioMetricSummaryArgs> {
  @gte('metric.spammed.allTimeRate', SPAM_WARN_LEVEL)
  tooMuchSpam!: boolean;

  get actionInfo() {
    let actionKey = `${this.args.actionType}_action`;
    return actionInfo(actionKey as ActionType);
  }
  get link() {
    return this.args.link ?? true;
  }
  get spamTooltip() {
    let rate = format('.1%')((this.args.metric as any).spammed.allTimeRate);

    return `<b>A ${rate} spam rate is too high!</b><br>
    Email win@customer.io for advice on how to improve`;
  }
  get title() {
    return this.args.title ?? 'All-time';
  }

  get shouldDisplayUndeliverable() {
    let isUndeliverableIncluded = this.args.visibleMetrics ? this.args.visibleMetrics.includes('undeliverable') : false;
    return (this.args.useMessageLimits as boolean) && (this.args.visibleMetrics == null || isUndeliverableIncluded);
  }

  get shouldDisplayBounced() {
    return this.shouldDisplay('bounced');
  }

  get shouldDisplayDelivered() {
    return this.shouldDisplay('delivered');
  }

  get shouldDisplayOpened() {
    return this.shouldDisplay('opened');
  }

  get shouldDisplaySuppressed() {
    return this.shouldDisplay('suppressed');
  }

  get shouldDisplaySpammed() {
    return this.shouldDisplay('spammed');
  }

  get shouldDisplayUnsubscribed() {
    return this.shouldDisplay('unsubscribed');
  }

  get shouldDisplayTopicUnsubscribed() {
    return this.shouldDisplay('topic_unsubscribed');
  }

  get shouldDisplayClicked() {
    return this.shouldDisplay('clicked');
  }

  get shouldDisplayConverted() {
    return this.shouldDisplay('converted');
  }

  get shouldDisplayFailed() {
    return this.shouldDisplay('failed');
  }

  get shouldDisplayClickedToOpened() {
    return this.shouldDisplay('clicked_to_opened');
  }

  get shouldDisplaySent() {
    return this.shouldDisplay('sent');
  }

  shouldDisplay(text: Measure): boolean {
    let isIncluded = this.args.visibleMetrics?.includes(text) ?? false;

    return !this.args.visibleMetrics || isIncluded;
  }
}
